import { ConsentCategory } from './consent'

export const COOKIE_CATEGORIES: Record<string, ConsentCategory> = {
	_ga_VTRGXDJKH1: ConsentCategory.analytics,
	_ga: ConsentCategory.analytics,
	_gid: ConsentCategory.analytics,
	locale: ConsentCategory.functionality,
}
